import { queryOptions } from "@tanstack/react-query";
import { fetchAllPostsWithCategories, fetchPostBySlug, fetchSidebarWidgets } from "./posts.functions";

export const allPostsQueryOptions = queryOptions({
  queryKey: ["blog", "posts", "all"],
  queryFn: () => fetchAllPostsWithCategories(),
  staleTime: 60_000,
});

export const postBySlugQueryOptions = (slug: string) =>
  queryOptions({
    queryKey: ["blog", "posts", slug],
    queryFn: () => fetchPostBySlug({ data: { slug } }),
    staleTime: 60_000,
  });

export const sidebarWidgetsQueryOptions = (sidebar: string) =>
  queryOptions({
    queryKey: ["blog", "widgets", sidebar],
    queryFn: () => fetchSidebarWidgets({ data: { sidebar } }),
    staleTime: 5 * 60_000,
  });

export type { BlogPost, BlogCategory, AllPostsPayload, SidebarWidget } from "./types";
